/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_ProofInputs */

const en_mk_foot_proof = /** @type {(inputs: Mk_Foot_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proof-of-Done`)
};

const id_mk_foot_proof = /** @type {(inputs: Mk_Foot_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proof-of-Done`)
};

/**
* | output |
* | --- |
* | "Proof-of-Done" |
*
* @param {Mk_Foot_ProofInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_proof = /** @type {((inputs?: Mk_Foot_ProofInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_ProofInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_proof(inputs)
	return en_mk_foot_proof(inputs)
});